import React from 'react'
import Footer from './Components/Footer';
import Header from './Components/Header'
import HomeScreen from './Components/HomeScreen';


const App = () => {
  return (
    <div>
      <Header />
      <HomeScreen />
      <Footer />
    </div>
  )
}

export default App